module.exports = __webpack_public_path__ + "img/notes.8914c5f5.svg";